/**
 * Blocks Accessibility
 * Auto-enhances content blocks with ARIA roles and labels
 */

import BaseA11yEnhancer from './base-a11y-enhancer';

const slug = (text) =>
    text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .substring(0, 50);

new BaseA11yEnhancer({
    selector: 'section, .block-section, [class*="component-"]',
    observeDOM: false,

    enhance: (block) => {
        if (block.tagName !== 'SECTION' && !block.hasAttribute('role')) {
            block.setAttribute('role', 'region');
        }

        const h = block.querySelector('h1, h2, h3, h4');
        if (h) {
            h.id ||= `s-${slug(h.textContent)}`;

            if (!block.getAttribute('aria-label') && !block.getAttribute('aria-labelledby')) {
                if (block.tagName !== 'SECTION') {
                    block.setAttribute('aria-labelledby', h.id);
                }
            }

            block.querySelectorAll('a:not([aria-label])').forEach((a) => {
                const txt = a.textContent.trim();
                if (txt) a.setAttribute('aria-label', `${txt} - ${h.textContent.trim()}`);
            });
        }

        block.querySelectorAll('svg:not([aria-label]):not([role])').forEach((svg) => {
            svg.setAttribute('aria-hidden', 'true');
        });

        block.querySelectorAll('img:not([alt]), img[alt=""]').forEach((img) => {
            img.role = 'presentation';
            img.alt = '';
        });
    },
});

const main =
    document.querySelector('main') ||
    (() => {
        const m = document.createElement('main');
        m.id = 'main-content';
        const header = document.querySelector('header');
        const footer = document.querySelector('footer');
        const content = [];
        let el = header?.nextElementSibling;

        while (el && el !== footer) {
            if (!el.matches('header')) content.push(el);
            el = el.nextElementSibling;
        }

        if (content.length) {
            content[0].parentNode.insertBefore(m, content[0]);
            content.forEach((c) => m.appendChild(c));
        }

        return m;
    })();

document.querySelector('#btnScrollMainContent')?.addEventListener('click', (e) => {
    e.preventDefault();
    main.scrollIntoView({ behavior: 'smooth' });
    main.tabIndex = -1;
    main.focus();
    main.onblur = () => main.removeAttribute('tabindex');
});
